import { css } from 'styled-components';
import {
  getTypography, TypographyName, getSpacing, SpacingName, FontWeight, ThemedFunctor, BreakpointQueryName,
} from '@doveit/lego';

export const header: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
  ${getSpacing.paddingBottom(theme, SpacingName.MEDIUM)}
  max-width: 50rem;
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H3)}
`;

export const details: ThemedFunctor = ({
  theme,
}) => css`
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  flex-wrap: wrap;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-wrap: no-wrap;
  }
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  color: ${theme.palettes.neutrals.medium};
  margin-top: .5rem;
  width: 100%;

  span {
    display: block;
  }

  ${theme.breakpoints.up(BreakpointQueryName.SM)} {
    span {
      margin-right: 0.5rem;
      display: inline;

      &:last-of-type {
        margin-right: 0;
      }

      &:not(:last-of-type)::after {
        content: '-';
        margin-left: 0.5rem;
      }
    }
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: auto;
  }
`;

export const categories: ThemedFunctor = () => css`
  display: flex;
  align-items: baseline;
`;

export const categoriesLabel: ThemedFunctor = ({ theme }) => css`
  white-space: nowrap;
  color: ${theme.palettes.neutrals.medium};
  margin-right: .5rem;
`;

export const divider: ThemedFunctor = ({
  theme,
}) => css`
 display: none;
 color: ${theme.palettes.neutrals.medium};
 ${getSpacing.padding(theme, [0, SpacingName.SMALLER])}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }
`;

export const image: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginBottom(theme, SpacingName.MEDIUM)}

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const share: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.MEDIUM, 0, SpacingName.SMALL])}
  ${getTypography(theme, TypographyName.BODY)}
  font-weight: ${FontWeight.BOLD};
`;

export const rapidLinks: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.paddingTop(theme, SpacingName.MEDIUM)}
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  border-top: 1px solid ${theme.palettes.neutrals.lighter};
`;

export const related: ThemedFunctor = ({
  theme,
}) => css`
  > * {
    ${getSpacing.margin(theme, [SpacingName.MEDIUM, 0])}
  }
`;
